import styled from "@emotion/styled";
import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";

import MainNavLink from "~/components/links/MainNavLink";
import Subnav from "~/components/Subnav";
import { NavLinkWrapper } from "~/components/Header";
import { sanitizeForId } from "~/utilities/helpers";
import { setMatchSubNavHeight } from "~/utilities/headerHelpers";

import useOnClickOutside from "~/hooks/useOnClickOutside";

const MainNavListItem = styled.li`
    display: flex;
    align-items: center;
    position: relative;
`;

const MainNavigation = ({
    linkLabel,
    linkUrl,
    newTabOverride = "default",
    subItems = [],
    index,
    dispatch,
    openedSubnavs = {},
    tagRef = {},
    dropdownLabel,
}) => {
    const navLinkWrapperRef = useRef();
    const secondarySubRef = useRef();
    const tertiarySubRef = useRef();
    const submenuId = `${sanitizeForId(linkLabel)}-${index}`;
    const hasDropdown = subItems && !!subItems.length;
    const isNavOpened = openedSubnavs.secondary === submenuId;
    const indexZeroMainNavRef = index === 0 ? tagRef : navLinkWrapperRef;

    useEffect(() => {
        setMatchSubNavHeight(secondarySubRef, tertiarySubRef);
    }, [openedSubnavs]);

    useOnClickOutside(indexZeroMainNavRef, () => {
        if (isNavOpened) {
            dispatch({ type: "HANDLE_CLICK_OUTSIDE" });
        }
    });

    return (
        <MainNavListItem>
            <NavLinkWrapper
                isNavOpened={isNavOpened && hasDropdown}
                ref={indexZeroMainNavRef}
                key={linkLabel}
            >
                <MainNavLink
                    {...{
                        hasDropdown,
                        submenuId,
                        linkLabel,
                        linkUrl,
                        newTabOverride,
                        isNavOpened,
                        dispatch,
                        openedSubnavs,
                        dropdownLabel,
                    }}
                />
                {hasDropdown > 0 && (
                    <Subnav
                        level="secondary"
                        isOpen={isNavOpened}
                        items={subItems}
                        topLinkLabel={linkLabel}
                        topLinkUrl={linkUrl}
                        topLinkNewTabOverride={newTabOverride}
                        secondarySubRefProp={secondarySubRef}
                        tertiarySubRefProp={tertiarySubRef}
                        {...{
                            openedSubnavs,
                            dispatch,
                        }}
                    />
                )}
            </NavLinkWrapper>
        </MainNavListItem>
    );
};

MainNavigation.propTypes = {
    linkLabel: PropTypes.string.isRequired,
    linkUrl: PropTypes.string.isRequired,
    newTabOverride: PropTypes.string,
    subItems: PropTypes.arrayOf(PropTypes.shape({})),
    index: PropTypes.number.isRequired,
    dispatch: PropTypes.func.isRequired,
    openedSubnavs: PropTypes.shape({}),
    tagRef: PropTypes.object,
    dropdownLabel: PropTypes.string,
};

export default MainNavigation;
